import { Banner, Button } from '@wistia/vhs';
import type { JSX } from 'react';
import { useState } from 'react';
import styled from 'styled-components';

const StyledBanner = styled(Banner)`
  background-color: ${({ theme }) => theme.color.grey200};
  left: 50%;
  max-width: 84vw;
  position: fixed;
  top: 24px;
  transform: translateX(-50%);
  width: max-content;
  z-index: ${({ theme }) => theme.zIndex.Tooltip};
`;

export const PreviewBanner = (): JSX.Element | null => {
  const [showPreviewBanner, setShowPreviewBanner] = useState(true);

  return showPreviewBanner ? (
    <StyledBanner>
      <Banner.Body>
        <Banner.Title>This is only a preview.</Banner.Title>
        Do not share this link with your audience. Any information entered on this page will not be
        saved.
      </Banner.Body>
      <Banner.RightGutter>
        <Button
          onClick={() => {
            setShowPreviewBanner(false);
          }}
        >
          Close
        </Button>
      </Banner.RightGutter>
    </StyledBanner>
  ) : null;
};
